import { SvgIcon } from '@mui/material';
import { svgStyles } from '../styles';

const { secondaryText } = svgStyles;

const IconArrowDropDown = (props) => {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.5248 15.8049C11.7875 16.0646 12.2118 16.0646 12.4752 15.8049L18.715 9.64154C19.095 9.26666 19.095 8.65672 18.715 8.28117C18.335 7.90628 17.7182 7.90628 17.3382 8.28117L11.9997 13.5535L6.66246 8.28117C6.28177 7.90628 5.66502 7.90628 5.28501 8.28117C4.905 8.65672 4.905 9.26666 5.28501 9.64154L11.5248 15.8049Z" style={{...secondaryText}} fill="#70728F"/>
    </SvgIcon>
  );
};

export default IconArrowDropDown;
